import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  signal,
} from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth/auth.service';

@Component({
  selector: 'app-cadastrar-empresa-dados-gerais',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatGridListModule,
    MatSelectModule,
    NgxMaskDirective,
    MatButtonModule,
  ],
  providers: [provideNgxMask()],
  templateUrl: './cadastrar-empresa-dados-gerais.html',
  styleUrls: ['./cadastrar-empresa-dados-gerais.scss'],
})
export class CadastrarEmpresaDadosGerais implements OnInit, OnChanges {
  @Input() dadosCompartilhados: any;

  // Cache das cidades filtradas para evitar processamento desnecessário
  cidadeOptionsFiltradas: Array<{ id_cidade: number; nome: string }> = [];
  private ultimoCodigoUf: number | null = null;

  formBloqueado = signal(false);

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {}

  ngOnInit(): void {
    this.atualizarCidadesFiltradas();

    if (this.dadosCompartilhados?.modoEdicaoAtivo) {
      this.formBloqueado.set(
        this.authService.isGestor() || this.authService.isSaude()
      );
    } else {
      this.formBloqueado.set(this.authService.isSaude());
    }

    this.dadosCompartilhados?.empresaForm
      ?.get('ufResidencia')
      ?.valueChanges.subscribe(() => {
        this.atualizarCidadesFiltradas();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dadosCompartilhados']) {
      this.atualizarCidadesFiltradas();
    }
  }

  private atualizarCidadesFiltradas(): void {
    const codigoUf =
      this.dadosCompartilhados?.empresaForm?.get('ufResidencia')?.value;

    // Só atualiza se o código UF mudou (evita processamento desnecessário)
    if (codigoUf === this.ultimoCodigoUf) {
      return;
    }

    this.ultimoCodigoUf = codigoUf;

    if (!codigoUf) {
      this.cidadeOptionsFiltradas = [];
      return;
    }

    // Atualiza as cidades uma única vez
    this.cidadeOptionsFiltradas = this.dadosCompartilhados.estadosCidadesService
      .getMunicipiosPorEstadoCodigo(codigoUf)
      .map((municipio: any) => ({
        id_cidade: municipio.codigo_ibge,
        nome: municipio.nome,
      }));
  }

  onSalvar(): void {
    if (this.dadosCompartilhados?.onSalvar) {
      this.dadosCompartilhados.onSalvar();
    }
  }

  onCancelar(): void {
    this.router.navigate(['/empresas']);
  }
}
